<template>
  <div class="stateInventory responsive-menu">
    <div class="responsive-menu__child">
      <PageHeader title="Tax Summary by Category" :links="[
        { name: 'home', label: 'Home' },
        { name: 'reports', label: 'Reports' },
        { name: 'financeReport', label: 'Finance' },
        {
          name: 'salesTaxSummaryCategory',
          label: 'Tax Summary by Category',
        },
      ]" @export="exportToCsv" :disableExport="!reportData" />
      <br class="no-print" />
      <ReportFilter class="no-print" :filterByTime="true" @submit-filter="performGetReport" :isLoading="isLoading"
        :percentage="percentageCompleted" />
      <div class="report-container">
        <!-- This could be a component -->
        <div class="report-body" v-if="reportData">
          <table id="table-report">
            <thead>
              <tr>
                <th align="left">Period</th>
                <th align="left">Category</th>
                <th align="right">Subtotal</th>
                <th align="right">Discount</th>
                <th align="right">Total Sales</th>
                <th align="right">Taxes</th>
                <th align="right">Excise 10%</th>
                <th align="right">Excise 20%</th>
                <th align="right">Excise 25%</th>
                <th align="right">County Excise</th>
                <th align="right">Retailers Occupation</th>
                <th align="right">State Sales Tax-Adult Use</th>
                <th align="right">State Sales Tax-Non Cannabis</th>
                <!-- <th align="right">Other Tax</th> -->
                </tr>
            </thead>

            <tbody>
              <tr class="report-body__row"></tr>
              <tr v-for="[day, value] in Object.entries(reportData.list)" :key="day">
                <td>{{ value.period }}</td>
                <td>{{ value.category }}</td>
                <td align="right"> {{ Utilities.formatPrice(value.subTotal) }} </td>
                <td align="right"> {{ Utilities.formatPrice(value.discount) }} </td>
                <td align="right"> {{ Utilities.formatPrice(value.total) }} </td>
                <td align="right"> {{ Utilities.formatPrice(value.totalAllInTax) }} </td>
                <td align="right"> {{ Utilities.formatPrice(value.exciseTax10) }} </td>
                <td align="right"> {{ Utilities.formatPrice(value.exciseTax20) }} </td>
                <td align="right"> {{ Utilities.formatPrice(value.exciseTax25) }} </td>
                <td align="right"> {{ Utilities.formatPrice(value.countyExciseTaxAdultUse) }} </td>
                <td align="right"> {{ Utilities.formatPrice(value.retailersOccupationTax) }} </td>
                <td align="right"> {{ Utilities.formatPrice(value.stateSalesTaxAdultUse) }} </td>
                <td align="right"> {{ Utilities.formatPrice(value.stateSalesTaxNonCannabis) }} </td>
                <!-- <td align="right"> {{ Utilities.formatPrice(value.otherTax) }} </td> -->
              </tr>
            </tbody>
            <tr class="skip-export">
              <td colspan="100%">
                <hr class="line1" />
              </td>
            </tr>
            <tr>
              <td colspan="2">Totals</td>
              <td align="right">
                {{ Utilities.formatPrice(reportData.total.subTotal) }}
              </td>
              <td align="right">
                {{ Utilities.formatPrice(reportData.total.discount) }}
              </td>
              <td align="right">
                {{ Utilities.formatPrice(reportData.total.total) }}
              </td>
              <td align="right">
                {{ Utilities.formatPrice(reportData.total.totalAllInTax) }}
              </td>
              <td align="right">
                {{ Utilities.formatPrice(reportData.total.exciseTax10) }}
              </td>
              <td align="right">
                {{ Utilities.formatPrice(reportData.total.exciseTax20) }}
              </td>
              <td align="right">
                {{ Utilities.formatPrice(reportData.total.exciseTax25) }}
              </td>
              <td align="right">
                {{ Utilities.formatPrice(reportData.total.countyExciseTaxAdultUse) }}
              </td>
              <td align="right">
                {{ Utilities.formatPrice(reportData.total.retailersOccupationTax) }}
              </td>
              <td align="right">
                {{ Utilities.formatPrice(reportData.total.stateSalesTaxAdultUse) }}
              </td>
              <td align="right">
                {{ Utilities.formatPrice(reportData.total.stateSalesTaxNonCannabis) }}
              </td>
              <!-- <td align="right">
                {{ Utilities.formatPrice(reportData.total.otherTax) }}
              </td> -->
            </tr>
            <tr class="skip-export"></tr>
            <tr class="skip-export">
              <td colspan="100%">
                <hr class="line1" />
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/Header/Header.vue";
import { mapActions, mapGetters } from "vuex";
import ReportFilter from "@/components/ReportFilter/ReportFilter";
import Utilities from "@/lib/Utilities";
import ReportHelper from "@/lib/report/index.js";

export default {
  data() {
    return {
      Utilities,
    };
  },
  components: {
    PageHeader,
    ReportFilter,
  },
  created: function () {
    this.setPageTitle("Tax Summary by Category");
  },
  mounted: function () {
    const today = new Date();
    this.selectedPeriod = {
      from: new Date(new Date().setDate(today.getDate() - 7)),
      to: today,
    };
  },
  computed: {
    ...mapGetters({
      isLoading: "reports/isLoading",
      getData: "reports/getData",
      percentageCompleted: 'reports/percentageCompleted'
    }),
    reportData() {
      return this.getData;
    },
  },
  methods: {
    ...mapActions({
      generateReport: "reports/generate",
      clearData: "reports/clearData",
    }),
    exportToCsv() {
      var table = document.getElementById("table-report");
      ReportHelper.exportToExcel(table, "SalesTaxSummaryCategory");
    },
    performGetReport(filter) {
      let reportType = "salesTaxSummaryCategory";
      this.generateReport({
        reportType,
        ...filter,
      });
    },
  },
  beforeDestroy() {
    this.clearData()
  }
};
</script>

<style lang="scss">
@import "./_salesTaxSummaryCategory.scss";
</style>